import ReactDOM from 'react-dom';
import App from '@app/App';
import reportWebVitals from './reportWebVitals';
import '@services/mixpanel/setup';

ReactDOM.render(<App />, document.getElementById('root'));

reportWebVitals();
